module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel02_1280_1280_en-8fa7087906c5208a978f8417d046adee.jpg";